export const importErrorCopies = {
  id_required: 'A esta fila le falta el ID de Reveni, necesario para identificar el producto.',
  id_invalid: 'El ID debe ser un número entero, no texto ni un decimal.',
  sku_required: 'Falta el SKU, todas las filas necesitan uno.',
  barcode_too_long: 'El código de barras es demasiado largo.',
  hs_code_too_short: 'El código HS es demasiado corto, necesita al menos 6 dígitos.',
  weight_invalid: 'El peso debe ser un número, como 1.5 o 200.',
  weight_unit_invalid: 'La unidad de peso no es válida, usa g, kg, oz o lb.',
  country_of_origin_unknown: 'El país de origen no es un código válido, usa un código ISO de 2 letras, como ES o US.',
  export_price_country_required:
    'Falta el país del precio de exportación, obligatorio cuando se rellena cualquier campo de precio de exportación.',
  export_price_country_unknown:
    'El país del precio de exportación no es un código válido, usa un código ISO de 2 letras.',
  export_price_required: 'Falta el precio de exportación, obligatorio cuando se indica una moneda.',
  export_price_currency_invalid: 'La moneda debe ser un código de 3 letras, como EUR o USD.',
  export_price_invalid: 'Quita el símbolo de moneda del precio, solo debe contener el número.',
  export_hts_code_too_short: 'El código HTS de ese país es demasiado corto.',
  warehouse_store_location_required:
    'Falta la ubicación del almacén, obligatoria cuando se indica un detalle de ubicación.',
  warehouse_store_location_not_found: 'Esa ubicación no existe en tu tienda.',
  warehouse_store_location_invalid: 'La ubicación del almacén debe ser un número entero.',
  product_detail_location_too_long: 'El detalle de ubicación es demasiado largo, no puede superar los 25 caracteres.',
  scientific_notation:
    'El valor está en notación científica y Excel ha recortado sus dígitos. Usa el archivo .xlsx o da formato de texto a la columna antes de guardar el CSV.',
}

export const importFileErrorTypes = {
  fileEmpty: 'file_empty',
  missingRequiredColumns: 'missing_required_columns',
  fileUnreadable: 'file_unreadable',
  fileTooLarge: 'file_too_large',
  unexpected: 'unexpected',
}

export const importFileErrorCopies = {
  [importFileErrorTypes.fileEmpty]: 'El archivo está vacío o no tiene fila de cabecera.',
  [importFileErrorTypes.missingRequiredColumns]: 'Faltan columnas obligatorias en el archivo: {{columns}}.',
  [importFileErrorTypes.fileUnreadable]: 'No se ha podido leer el archivo como un libro de Excel (.xlsx).',
  [importFileErrorTypes.fileTooLarge]:
    'El archivo contiene más datos de los que admite una importación, divídelo en archivos más pequeños.',
  [importFileErrorTypes.unexpected]: 'No se ha podido procesar el archivo. Revísalo e inténtalo de nuevo.',
}

export const counterTypes = {
  success: 'success',
  warning: 'warning',
}

export const emptyValuePlaceholder = '—'
